import { CadastroComponent } from './cadastro/cadastro.component';
import { LoginTesteComponent } from './login-teste/login-teste.component';
import { Routes } from '@angular/router';

export const AppRoutes: Routes = [
  {
        path: '',
        component: LoginTesteComponent
      },
      {
        path: 'solicitacao',
        component: CadastroComponent
      },
     { path: '**', redirectTo: '/' }
];
